import React from 'react'

const ArrowBaloon = () => {
  return (
    <svg viewBox='0 0 8 13'>
      <path
        fill='#fff'
        stroke='#cbcbcb'
        className='cls-1'
        d='M-.52.5l.19.14L7.19,6.5-.33,12.36l-.19.14'
      />
    </svg>
  )
}

export default ArrowBaloon
